import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink, MESSAGES, IMAGES } from "@/constants/site";

const EASE = [0.22, 1, 0.36, 1];

export const CompramosCabelo = () => (
  <section id="venda-cabelo" data-testid="buy-hair-section" className="relative bg-[#0A0A0B] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative overflow-hidden rounded-3xl border border-[#D4AF37]/20 bg-gradient-to-br from-[#1C1B1F] to-[#141416] p-8 sm:p-12 lg:p-16"
      >
        <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#D4AF37]/10 blur-[100px]" />
        <div className="relative grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-[#F9F8F6]">
              Venda seu Cabelo
            </p>
            <h2 className="font-display text-3xl font-semibold tracking-tight text-[#F9F8F6] sm:text-4xl lg:text-5xl">
              COMPRAMOS SEU <span className="italic text-gold-gradient">CABELO</span>
            </h2>
            <p className="mt-6 text-base leading-relaxed text-[#A1A09E] sm:text-lg">
              Você tem cabelo natural e quer vender? Nós compramos cabelo humano
              com avaliação presencial e atendimento transparente. Fale com a
              nossa equipe e agende sua avaliação.
            </p>
            <motion.a
              href={waLink(MESSAGES.compraCabelo)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="buy-hair-whatsapp-btn"
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              className="group relative mt-9 inline-flex items-center gap-3 overflow-hidden rounded-full border border-white/20 bg-[#0A0A0B] px-8 py-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F9F8F6] shadow-[inset_0_1px_0_rgba(255,255,255,0.18),0_20px_45px_-12px_rgba(0,0,0,0.9)] transition-all duration-300 hover:-translate-y-0.5 hover:border-white/35 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.25),0_28px_55px_-12px_rgba(0,0,0,0.95)] active:translate-y-0"
            >
              <span className="absolute inset-0 -translate-x-full bg-white/30 transition-transform duration-500 group-hover:translate-x-full" />
              <WhatsAppIcon className="relative h-5 w-5" />
              <span className="relative">Quero vender meu cabelo</span>
            </motion.a>
          </div>
          <motion.figure
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.15 }}
            className="relative"
          >
            <div className="absolute -inset-3 rounded-3xl border border-[#D4AF37]/30" />
            <img
              src={IMAGES.placaCompramos}
              alt="Placa do Salão Estrela: compramos e vendemos cabelo"
              loading="lazy"
              className="relative w-full rounded-2xl object-cover"
            />
          </motion.figure>
        </div>
      </motion.div>
    </div>
  </section>
);
